import React from 'react'
import Footer from '../Footer';
import Header from '../Header';
import Servicedata from '../Api/service';

function Insuranceservice() {

  

  return (
    <>
      <Header/>

      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <h1 className="text-white">Insurance</h1>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="container">
          <div className="container section-title" data-aos="fade-up">
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-light rounded-pill"
              >
                SERVICES
              </button>
            </div>
            <h1 style={{ textAlign: 'center' }}>
              <span>Insurance</span> <span className="link-primary">Service</span>
            </h1>
          </div>
        </div>
      </section>

      <section id="about" className="about section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay={100}>
              <img src="assets/img/Services/insurance-service.png" alt className="img-fluid" />
            </div>
            <div className="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay={200}>
              <div className="about-content ps-0 ps-lg-3">
                {/* <h3>"Innovation is not just our Strength; it is our Foundation."</h3> */}
                <p className="fst-italic">
                  <b>Sai Financial Service</b> provides insurance services to help secure your future and safeguard your assets. We offer a range of insurance policies from reputed companies, including health, life, and vehicle insurance.
                </p>
                <h3>Loan Types Offered:</h3>
                <ol style={{ listStyle: 'disc' }}>
                  <li><p className="fst-italic"><b>Health Insurance:</b> Protect yourself and your family with comprehensive health insurance policies.</p></li>
                  <li><p className="fst-italic"><b>Life Insurance: </b> Ensure financial security for your loved ones in case of an unfortunate event.</p></li>
                  <li><p className="fst-italic"><b>Vehicle Insurance:</b> Safeguard your vehicle with extensive coverage, including third-party and own-damage insurance.</p></li>
                  <li><p className="fst-italic"><b>Travel Insurance:</b> Get peace of mind while traveling with travel insurance plans that cover emergencies and losses.</p></li>
                  <li><p className="fst-italic"><b>Others Insurance:</b> We also offer other insurance products such as home insurance, critical illness insurance, business insurance and others to provide all-around protection.</p></li>
                </ol>
                <h3>Why Choose Us?</h3>
                <ol style={{ listStyle: 'disc' }}>
                  <li><p className="fst-italic"><b>Variety of Insurance Plans:</b> We work with multiple insurance providers to offer you a wide range of policy options.</p></li>
                  <li><p className="fst-italic"><b>Professional Advice:</b> Our insurance advisors help you select the best coverage based on your requirements.</p></li>
                  <li><p className="fst-italic"><b>Hassle-Free Claims Assistance:</b> In case of any claims, we provide full support to ensure a smooth process.</p></li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="container section-title" data-aos="fade-up">
            <h1 style={{ textAlign: 'center' }}>
              <span>Insurance</span> <span className="link-primary">Service</span>
            </h1>
          </div>
        </div>
      </section>
      <Servicedata/>
      <Footer />
    </>
  )
}

export default Insuranceservice
